import { useTranslation } from 'react-i18next';

import { Select } from '@myphx-engineering/phx-design-system';

import type { MedicationStrengthInfoFragment } from '../../graphql/generated/graphql';
import { getStrengthValue } from '../../util';

export const MedicationStrengthSelect = ({
    strengths,
    selectedStrength,
    setSelectedStrength,
}: {
    strengths?: MedicationStrengthInfoFragment[];
    selectedStrength: string;
    setSelectedStrength: (value: string) => void;
}) => {
    const { t } = useTranslation(['myphx']);

    const data = strengths?.map((strength) => {
        const strengthValue = getStrengthValue(
            strength?.strengthValue,
            strength?.strengthUnit
        );

        return {
            value: strengthValue,
            label: strengthValue,
        };
    });

    return (
        <Select
            placeholder="-"
            disabled={(strengths?.length ?? 0) <= 1}
            label={t('drugConfig.strength')}
            value={selectedStrength === '' ? '-' : selectedStrength}
            onChange={(value) => value && setSelectedStrength(value)}
            data={data}
        />
    );
};
